export default __webpack_public_path__ + "static/media/Filter.4c82b3d3.svg";